var map = {
	"./background.png": 2437,
	"./background.svg": 7313,
	"./prize_1.png": 1451,
	"./prize_1@2x.png": 2206,
	"./prize_2.png": 8376,
	"./prize_2@2x.png": 3419,
	"./prize_3.png": 2653,
	"./prize_3@2x.png": 4111,
	"./prize_4.png": 8875,
	"./prize_4@2x.png": 4245,
	"./user_prizes/1.svg": 6128,
	"./user_prizes/2.svg": 8133,
	"./user_prizes/3.svg": 5554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9961;